import { clearAuthCookies } from "@/api/tokens"

export function useLogout() {
  return () => {
    clearAuthCookies()
    window.location.href = "/"
  }
}
